import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

import BaseSubscription, { TBaseSubscriptionProps } from './BaseSubscription';

const StyledBaseSubscription = styled(BaseSubscription)<TBaseSubscriptionProps>`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    
    align-items: start;

    @media(min-width: ${wideBreakpoints.mobile}) {
        gap: 4px;
    }
`;

export default StyledBaseSubscription;
